<template>
	<v-app-bar color="secondary" dark dense :clipped-left="$vuetify.rtl" :clipped-right="!$vuetify.rtl" style="height: 68px;padding:10px 0">
		<v-img src="/logo-wide.png" height="65px" style="max-width:75px" />
		<v-toolbar-title>
			<strong class="mr-1 font-weight-black">{{ longTitle }}</strong>
			&nbsp;
			<!-- <span class="orange--text">جت اقساط</span> -->
		</v-toolbar-title>
		<v-spacer />
		<v-btn @click="goToLogin">ورود به پنل کاربری</v-btn>
	</v-app-bar>
</template>

<script>
	import { get } from 'vuex-pathify'
	import router from '@/router'
	// Utilities

	export default {
		name: 'LandingAppBar',

		components: {

		},
		data() {
			return {

			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle'
			])
		},
		methods: {
			goToLogin() {
				router.push({ name: 'Login' }).catch(() => { })
			}
		},
	}
</script>

<style lang="sass">
</style>
